import { Component } from '@angular/core';

@Component({
  selector: 'app-help-button',
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss']
})
export class HelpButtonComponent {

  link = 'https://buildin.ai/getit/842f4c12-b6f1-4b65-a669-85c20e0ec30a';
  constructor() { }
}
